import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Card, message, InputNumber } from "antd";
import { HEADERS_EXPORT_BEN, POST_UPDATE_EXPENSE } from "../../../API/apiUrls";
import axios from "axios";

const EditAdvancePaymentDetail = ({
  open,
  close,
  dataDefault,
  funcUpdateStatus,
}) => {
  const [loading, setLoading] = useState();
  const [isModal, setIsModal] = useState(false);
  const [form] = Form.useForm();

  const getExpenseAmount = (expenseTypeId) => {
    const expense = dataDefault?.workExpenseList?.find(
      (item) => item.expenseTypeId === expenseTypeId,
    );
    return parseFloat(expense?.NETPAY) || 0;
  };

  useEffect(() => {
    setIsModal(open);
    if (isModal) {
      console.log("dataDefault", dataDefault);

      form.setFieldsValue({
        feeCourt: getExpenseAmount(1), // ค่าธรรมเนียมศาล
        docShipingCost: getExpenseAmount(2), // ค่าส่งหมาย
        documentCost: getExpenseAmount(4), // ค่าจัดทำเอกสาร
      });
      setLoading(false);
    }
  }, [isModal]);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
    setIsModal(false);
  };

  const sendStatus = async (data) => {
    setLoading(true);

    try {
      console.log(data);
      await axios
        .post(POST_UPDATE_EXPENSE, data, { headers: HEADERS_EXPORT_BEN })
        .then(async (res) => {
          if (res.status === 200) {
            console.log("resQuery", res.data);
            funcUpdateStatus?.();
          } else {
            message.error("ไม่สามารถส่งข้อมูลได้");
            console.log("ไม่สามารถส่งข้อมูลได้");
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.status > 400) {
            message.error("ไม่สามารถส่งข้อมูลได้");
          }
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("เกิดข้อผิดพลาดในการอัพเดทข้อมูล");
    } finally {
      setLoading(false);
      handleCancel();
    }
  };

  const onFinish = (values) => {
    console.log(values);

    const putData = [
      {
        id: (() => {
          const existingExpense = dataDefault?.workExpenseList?.find(
            (item) => item.expenseTypeId === 1,
          );
          return existingExpense?.id || 0;
        })(),
        TMBILL: null,
        lawsuitId: dataDefault.lawsuitId,
        expenseTypeId: 1,
        NETPAY: values.feeCourt,
        NETPAY_DT: null,
        payTypeId: null,
        PAY: null,
        PAYDT: null,
        FLAG: null,
        CANDT: null,
        CANDT_USER: null,
        description: null,
      },
      {
        id: (() => {
          const existingExpense = dataDefault?.workExpenseList?.find(
            (item) => item.expenseTypeId === 2,
          );
          return existingExpense?.id || 0;
        })(),
        TMBILL: null,
        lawsuitId: dataDefault.lawsuitId,
        expenseTypeId: 2,
        NETPAY: values.docShipingCost,
        NETPAY_DT: null,
        payTypeId: null,
        PAY: null,
        PAYDT: null,
        FLAG: null,
        CANDT: null,
        CANDT_USER: null,
        description: null,
      },
      {
        id: (() => {
          const existingExpense = dataDefault?.workExpenseList?.find(
            (item) => item.expenseTypeId === 4,
          );
          return existingExpense?.id || 0;
        })(),
        TMBILL: null,
        lawsuitId: dataDefault.lawsuitId,
        expenseTypeId: 4,
        NETPAY: values.documentCost,
        NETPAY_DT: null,
        payTypeId: null,
        PAY: null,
        PAYDT: null,
        FLAG: null,
        CANDT: null,
        CANDT_USER: null,
        description: "",
      },
    ];

    console.log("putData", putData);
    sendStatus(putData);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครับ");
  };

  const feeCourtCost = (value) => {
    console.log(value);
  };

  const docShipingCost = (value) => {
    console.log(value);
  };

  const documentCost = (value) => {
    console.log(value);
  };

  const FormDisabledDemo = () => {
    return (
      <>
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            memo: null,
          }}
        >
          <Form.Item label="เลขสัญญา/เจ้าของสัญญา" name="ownerSign">
            {`${dataDefault?.CONTNO} - ${dataDefault?.SNAM}${
              dataDefault?.NAME1
            } ${dataDefault?.NAME2 ? dataDefault?.NAME2 : ""}`}
          </Form.Item>
          <Form.Item
            label="ค่าธรรมเนียมศาล"
            name="feeCourt"
            rules={[
              {
                required: true,
                message: "กรุณาใส่ค่าธรรมเนียมศาล !",
              },
            ]}
          >
            <InputNumber
              suffix="บาท"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              size="large"
              placeholder="กรุณาใส่ค่าธรรมเนียมศาล"
              style={{ width: "100%", color: "black" }}
              onChange={(value) => feeCourtCost(value)}
            />
          </Form.Item>

          <Form.Item
            label="ค่าส่งหมาย"
            name="docShipingCost"
            rules={[
              {
                required: true,
                message: "กรุณากรอกค่าส่งหมาย !",
              },
            ]}
          >
            <InputNumber
              suffix="บาท"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              size="large"
              placeholder="กรุณากรอกค่าส่งหมาย"
              style={{ width: "100%", color: "black" }}
              onChange={(value) => docShipingCost(value)}
            />
          </Form.Item>
          <Form.Item
            label="ค่าจัดทำเอกสาร"
            name="documentCost"
            rules={[
              {
                required: true,
                message: "กรุณากรอกค่าจัดทำเอกสาร !",
              },
            ]}
          >
            <InputNumber
              suffix="บาท"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              size="large"
              placeholder="กรุณากรอกจัดทำเอกสาร"
              style={{ width: "100%", color: "black" }}
              onChange={(value) => documentCost(value)}
            />
          </Form.Item>
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={handleCancel}
              style={{ color: "red", marginRight: "20px" }}
            >
              ปิด
            </Button>

            <Button style={{ color: "green" }} htmlType="submit">
              บันทึก
            </Button>
          </div>
        </Form>
      </>
    );
  };

  return (
    <>
      <Modal
        title="แก้ไขข้อมูล"
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
      >
        <Card>
          <FormDisabledDemo />
        </Card>
      </Modal>
    </>
  );
};
export default EditAdvancePaymentDetail;
